<template>
	<div class="reset-view" @click.stop>
		<div class="selection">
			<div v-for="layout in layouts" :key="layout.name" class="item" @click.stop="onItemClick(layout)">
				<div class="preview" :src="layout.previewImageUrl">
					<i class="material-icons">remove_circle</i>
					<span>No Preview</span>
				</div>
				<label>{{ layout.name }}</label>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import layouts from '@/definitions/layouts.json'
export default {
	name: 'NewView',
	data() {
		return {
			layouts
		}
	},
	methods: {
		...mapActions({
			loadTemplateLayout: 'loadTemplateLayout',
			setErrorMsg: 'ui/setErrorMsg',
			setActiveOverlay: 'ui/setActiveOverlay'
		}),
		async onItemClick(item) {

			try {

				await this.loadTemplateLayout({
					name: item.name
				});
				this.setActiveOverlay();

			} catch (err) {

				this.setErrorMsg({msg: 'Error loading layout: ' + err.message});
				this.setActiveOverlay({id: 'error'});
			}
		}
	},
	mounted() {
		this.activeLayout = this.layouts[0];
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.reset-view {
	color: #0D141A;
	background-color: #FFF;
/*	width: 650px;
	height: 200px;*/
	border-radius: 3px;
	transition: all 0.5s;
	display: flex;
	flex-direction: column;
	padding: 12px;
	font-size: 14px;
}

.selection {
	flex: 1 1 auto;
	display: flex;
	justify-content: space-evenly;
}

.actions {
	display: flex;
	justify-content: flex-end;
}

.item {
	width: 150px;
	height: 170px;
	padding: 8px;
	font-size: 14px;
	margin-right: 8px;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	border-radius: 4px;
	transition: all 0.2s ease-out;
	cursor: pointer;
}
.item:last-child {
	margin-right: 0;
}
.item:hover {
	background-color: #38BEEA66;

}

.preview {
	flex: 1 1 auto;
	display: flex;
	position: relative;
	flex-direction: column;
	color: #DDD;
}
.item:hover .preview {
	color: #FFF;
}

.preview span {
	white-space: nowrap;
	margin: auto;
	margin-top: 0;
	font-weight: bold;
}

label {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	margin-top: 4px;
	cursor: pointer;
}

i {
	margin: auto;
	font-size: 80px;
}

</style>



// WEBPACK FOOTER //
// src/components/NewView.vue